import React from "react";
import styles from "./QuizSkeleton.module.scss";

const QuizSkeleton: React.FC = () => {
  return (
    <div className={`container ${styles.skeletonContainer}`}>
      <div className={styles.skeletonHeader}></div>

      {[...Array(5)].map((_, index) => (
        <div key={index} className={styles.skeletonCard}>
          <div className={styles.skeletonHeader}></div>
          <div className={styles.skeletonInput}></div>
          <div className={styles.skeletonInput}></div>
          <div className={styles.skeletonButton}></div>
        </div>
      ))}
    </div>
  );
};

export default QuizSkeleton;
